import { APP_BAR_TOOLBAR_ICON_BUTTON_SX, APP_BAR_WHITE_ICON_BUTTON_SX } from "@/theme/appTheme";

/**
 * MUI `sx` for back and hamburger `IconButton`s in the authenticated app bar chrome.
 * Spreads `APP_BAR_WHITE_ICON_BUTTON_SX` and adds trailing margin before the title.
 */
export const APP_BAR_CHROME_ICON_BUTTON_SX = {
  ...APP_BAR_WHITE_ICON_BUTTON_SX,
  mr: 1,
};

/** Dark frosted toolbar row for mobile map overlay pages (Parcel Search map view). */
export const APP_BAR_GLASS_MAP_TOOLBAR_SX = {
  bgcolor: "rgba(36, 28, 48, 0.52)",
  backdropFilter: "blur(12px)",
  WebkitBackdropFilter: "blur(12px)",
  borderBottom: "1px solid rgba(255, 255, 255, 0.1)",
};

/** Opaque lavender toolbar for mobile map pages when the results drawer is closed. */
export const APP_BAR_LAVENDER_MAP_TOOLBAR_SX = {
  backgroundColor: "#F2EAF7",
  backgroundImage: "none",
  borderBottom: "1px solid var(--border-lavender, rgba(232, 224, 245, 0.5))",
};

/** Fixed AppBar shell when {@link APP_BAR_LAVENDER_MAP_TOOLBAR_SX} is active — blocks map bleed-through. */
export const APP_BAR_LAVENDER_MAP_APP_BAR_SX = {
  backgroundColor: "#F2EAF7",
  backgroundImage: "none",
};

/** Frosted circular controls on the dark map app bar. */
export const APP_BAR_GLASS_MAP_ICON_BUTTON_SX = {
  ...APP_BAR_TOOLBAR_ICON_BUTTON_SX,
  bgcolor: "rgba(28, 22, 38, 0.55)",
  backdropFilter: "blur(10px)",
  WebkitBackdropFilter: "blur(10px)",
  border: "1px solid rgba(255, 255, 255, 0.12)",
  boxShadow: "0 2px 12px rgba(0, 0, 0, 0.2)",
  color: "rgba(255, 255, 255, 0.92)",
  transition: "background-color 200ms ease, box-shadow 200ms ease, border-color 200ms ease, transform 100ms ease",
  "&:hover": {
    bgcolor: "rgba(28, 22, 38, 0.68)",
    borderColor: "rgba(255, 255, 255, 0.2)",
    boxShadow: "0 4px 16px rgba(0, 0, 0, 0.24)",
  },
  "&:active": {
    transform: "scale(0.98)",
  },
};

/** Title on the dark map app bar — light text instead of the default gradient. */
export const APP_BAR_GLASS_MAP_TITLE_SX = {
  background: "none",
  WebkitBackgroundClip: "unset",
  WebkitTextFillColor: "unset",
  backgroundClip: "unset",
  color: "rgba(255, 255, 255, 0.96)",
  textShadow: "0 1px 2px rgba(0, 0, 0, 0.28)",
};
